/**
 * Renact shared accordion behavior.
 * Wires click on any [data-renact-accordion-trigger] inside a [data-renact-accordion]
 * container to toggle `data-open` on the enclosing [data-renact-accordion-item] and
 * `aria-expanded` on the trigger. Sibling items are closed on open.
 *
 * Add attribute `data-renact-accordion-multi` to the container to allow multiple
 * items open at once (default: single-open behavior).
 */
(function () {
  'use strict';

  function bindAccordion(container) {
    container.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-renact-accordion-trigger]');
      if (!trigger || !container.contains(trigger)) return;
      var item = trigger.closest('[data-renact-accordion-item]');
      if (!item) return;

      var wasOpen = item.getAttribute('data-open') === 'true';
      var allowMulti = container.hasAttribute('data-renact-accordion-multi');

      if (!allowMulti) {
        container.querySelectorAll('[data-renact-accordion-item]').forEach(function (other) {
          if (other !== item) {
            other.setAttribute('data-open', 'false');
            var otherTrigger = other.querySelector('[data-renact-accordion-trigger]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      var nowOpen = !wasOpen;
      item.setAttribute('data-open', String(nowOpen));
      trigger.setAttribute('aria-expanded', String(nowOpen));
    });
  }

  function init() {
    document.querySelectorAll('[data-renact-accordion]').forEach(bindAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Handle sections added/re-rendered by the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-renact-accordion]').forEach(bindAccordion);
  });
})();
